<template>
  <b-card>
    <b-row>
      <b-col sm="5" class="text-left">
        <h4 id="traffic" class="card-title">{{ title }}</h4>
        <div class="small text-muted">{{ date | moment('MMMM (YYYY)') }}</div>
      </b-col>
      <b-col sm="7" class="d-none d-md-block">
        <b-button-toolbar class="float-right">
          <b-form-radio-group
            id="radiosBtn"
            buttons
            button-variant="outline-secondary"
            name="radiosBtn"
            v-model="selected"
          >
            <b-form-radio class="mx-0" value="day">Day</b-form-radio>
            <b-form-radio class="mx-0" value="type">Type</b-form-radio>
          </b-form-radio-group>
        </b-button-toolbar>
      </b-col>
    </b-row>
    <month-chart
      v-show="selected=='day'"
      class="chart-wrapper"
      style="height:300px;margin-top:40px;"
      height="300"
      :date="date"
    />
    <type-chart
      v-show="selected=='type'"
      class="chart-wrapper"
      style="height:300px;margin-top:40px;"
      height="300"
      :date="date"
    />
  </b-card>
</template>

<script>
import MonthChart from '@/components/Chart/MonthChart'
import TypeChart from '@/components/Chart/TypeChart'

export default {
  name: 'monthly-chart',
  components: {
    MonthChart,
    TypeChart
  },
  props: ['date'],
  data () {
    return {
      selected: 'day'
    }
  },
  computed: {
    title: function () {
      return this.selected === 'day' ? 'Income' : 'Popular'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/MonthlyChart.vue